<div class="wrapper-left-side">
  <div class="wrapper-page-title-and-product-data">
    <ui-page-header>Produktdetails</ui-page-header>

    <div class="wrapper-bundle-content">
      <div class="wrapper-header">
        <div class="wrapper-labels">
          <ui-product-bundle-valid-to-label
            [bundleType]="product().bundleType!"
            [validTo]="product().prices?.validTo"
          ></ui-product-bundle-valid-to-label>

          @if (!isSapBundle()) {
            <ui-product-bundle-max-order-count-label [maxOrderCount]="bundle().maxOrderCount"></ui-product-bundle-max-order-count-label>
          }
        </div>

        <label class="product-bundle-name">{{ product().details.name }}</label>

        <div class="bundle-info-description">{{ product().details.description }}</div>
      </div>

      <ui-product-detail-bundle-item-list
        [bundleType]="product().bundleType!"
        [bundle]="bundle()"
        [bundlePrices]="product().prices"
      ></ui-product-detail-bundle-item-list>
    </div>
  </div>
</div>

<div class="wrapper-right-side">
  <div class="wrapper-prices-and-controls">
    <ui-product-detail-bundle-prices
      [bundlePrices]="product().prices"
      [bundleType]="product().bundleType!"
      [bundle]="bundle()"
    ></ui-product-detail-bundle-prices>

    <hr>

    <ui-add-to-cart
      (addToShoppingListClicked)="onAddToShoppingList($event)"
      [defaultAmount]="1"
      [maxOrderAmount]="maxOrderAmount()"
      [orderButtonDisabled]="maxOrderCountReached() || !product().prices"
      [quantityCounterDisabled]="maxOrderCountReached() || maxOrderAmount() === 1"
      [showAddToShoppingList]="true"
      [showButtonLabels]="false"
      [sku]="product().sku"
      [product]="product()"
      [position]="0"
    ></ui-add-to-cart>

    @if (!isSapBundle()) {
      <div
        class="wrapper-order-count"
        [class.max-order-count-reached]="maxOrderCountReached()"
      >
        <ui-icon faName="circle-check" faStyle="light"></ui-icon>
        <span>
          {{ bundle().currentOrderCount }}/{{ bundle().maxOrderCount }}
          Pakete bereits eingelöst
        </span>
      </div>
    }
  </div>
</div>
